<template>
	<section>
		<compSteplist :status="getStatus" :progressStatus="getProgressStatus" style="margin-left: 160px"></compSteplist>
        <!-- 按钮展示 -->
        <div class="margin-bottom-10">
            <vButton v-if="formData.saleReturnPlanStatus === 10" class="margin-right-10" theme="success" @click="complateBill">收货完成</vButton>
            <vButton v-if="formData.saleReturnPlanStatus === 5 && this.handleAuth('fbb.returnplan.review')" class="margin-right-10" theme="success" @click="approve()">审核</vButton>
            <vButton v-if="formData.errorStatus !== 99999" class="margin-right-10" theme="info" @click="rehandle">重处理</vButton>
            <vButton v-if="formData.errorStatus !== 99999" class="margin-right-10" theme="gray" @click="ignoreAbnormal">忽略异常</vButton>
            <vButton v-if="formData.saleReturnPlanStatus===30" class="margin-right-10" theme="info" @click="rePush">重推仓库</vButton>
            <vButton v-if="!isActive" style="position:absolute;right:10px" theme="default" @click="cancel">返回</vButton>
        </div>
		<compWrapper title="基本信息" theme="primary">
			<compFormQuery class="margin-layout" :formdata="getBase" :value="formData" placeholder="--"></compFormQuery>
		</compWrapper>
		<compWrapper title="产品信息" theme="primary">
			<vTableSimple class="margin-layout" :data="productList" :columns="getCusproductColumns"></vTableSimple>
			<!-- <vButtonGroup slot="footer">
				<vButton
					v-for="item in getStatusBtns"
					:key="item.name"
					@click="item.run"
					:theme="item.theme"
				>{{item.name}}</vButton>
			</vButtonGroup> -->
		</compWrapper>
        <compWrapper title="图片信息" theme="success">
			<vTableSimple class="margin-layout" :data="photoList" :columns="getPhotoColumns"></vTableSimple>
		</compWrapper>
        <!-- <compPhotoLog v-bind="photoData"></compPhotoLog> -->
        <compWrapper :title="$t('global.common.attache',{defaultValue:'附件信息'})" theme="info">
			<compAttach
				class="margin-layout"
				ref="attachlist"
				:data="attachList"
				:activeid="id"
                :formData="formData"
				@on-update="getDetail"
			></compAttach>
		</compWrapper>
		<compLog wrapper :data="logList"></compLog>
		<vLoading size="large" transfer :loading="loading"></vLoading>
        <compModal
			v-model="modalProps.show"
			v-bind="modalProps"
            @on-close="closemodalprops"
		>
            <component ref="cusref" :is="modalProps.component"  v-bind="modalProps" @on-close="closemodalprops" v-on="modalProps.on"></component>
        </compModal>
	</section>
</template>

<script>
import { HttpPlanOrderDetail, HttpChangePlanOrderStatus, HttpChangePlanOrderReprocess, HttpChangePlanOrderIgnoreError, HttpChangePlanOrderRepushWareHouse, HttpCheckProcessDetail, HttpCheckProcessComplete } from '@/service/salesreturns';
import mixin from "../mixin";
import { mapGetters } from 'vuex';
import compAttach from './attach';
import compSteplist from '../steplist';
import compPhoto from '../photo.vue'

export default {
	mixins: [mixin],
    props:['activeids'],
	components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
		// compFormEdit: () => import("@components/templates/formedit"),
		compLog: () => import("@components/templates/log"),
		compModal: () => import("@components/templates/modal"),
        compAttach,
        compSteplist,
        compPhoto,
	},
	data() {
		return {
			loading: false,
			id: this.$route.query.id || this.activeids,
            isActive: this.activeids ? true : false,
			formData: {},
			productList: [],
            photoList:[],
			logList: [],
			modalProps: {
				show: false,
			},
            photoData: {},
			attachList: [],//附件列表
		};
	},
	created() {
		this.getDetail();
	},
	computed: {
        ...mapGetters('dictionary', ['getSelfmanageorgList', 'getCusproductList','getUserManageWarehouseList', 'getBillcusWareList']),
		/**
		 * 根据状态显示不同按钮
		 */
		// getStatusBtns() {
		// 	const status = this.formData.saleReturnPlanStatus;
		// 	const btn = [{
		// 		name: '审核',
		// 		theme: 'success',
		// 		show: status == 5,
		// 		run: this.approve && this.handleAuth('fbb.returnplan.review')
		// 	}]
		// 	return btn.filter(item => item.show);
		// },
		getBase() {
			return [{
				label: "退货计划单号",
				// key: "saleReturnPlanNo",
                render: ()=>{
                    return <div>
                        <span>{this.formData.saleReturnPlanNo}</span>
                        <span style="margin-left:10px;color:red;">{this.findRenderLabel(this.getErrorSimpleType, this.formData.errorStatus)}</span>
                    </div>
                }
				// query: true,
			},
            {
				label: "收货状态",
				key: "saleReturnPlanStatus",
				options: this.getPlanManageOrderStatus,
                render: (h)=>{
                    const status = this.formData.saleReturnPlanStatus;
                    const { label = '', theme} = this.getPlanCustomOrderStatus.find(function (item) {
                        return item.value == status
                    }) || {};
                    return <div>
                        <vButton ghost theme={theme} size="small" class="cursor-default">{label || '--'}</vButton>
                    </div>
                }
				// query: true,
			},
            {
				label: "确认状态",
				key: "confirmStatus",
				options: this.getConfirmStatus,
                render: (h)=>{
                    const status = this.formData.confirmStatus;
                    const { label = '', theme} = this.getConfirmStatus.find(function (item) {
                        return item.value == status
                    }) || {};
                    return <div>
                        <vButton ghost theme={theme} size="small" class="cursor-default">{label || '--'}</vButton>
                    </div>
                }
				// query: true,
			},
			{
				label: "退货仓库",
				key: "warehosueName",
				// tag: "vSelect",
				// options: this.getBillcusWareList,
			},
			{
				label: "项目",
				key: "lineName",
				// tag: "vSelect",
				// options: this.getCusproductList,
				// required: false,
				// props: {
				// 	filterable: true
				// },
			},
			{
				label: "来源单号",
				key: "sourceNo",
			},
			{
				label: "关联订单号",
				// tag: "vSelect",
				key: "saleOrderNo",
			},
			{
				label: "承运商",
				key: "carrierCode",
			},
			{
				label: "退货Tracking",
				key: "returnTrackingNo",
			},
			{
				label: "退货原因",
				key: "returnReason",
			},
            {   label: this.$t('fbb.alloment.client_organization',{defaultValue:'客户'}),
                key: 'organizationId',
                options: this.getSelfmanageorgList,
            },
            {
				label: "关联处理计划",
                key: 'relProcessNo',
                render: ()=>{
                    return <a onClick={this.handleOperates.bind(this,this.formData.relProcessId,'query')}>{this.formData.relProcessNo || '--'}</a>
                }
            }];
		},
		getCusproductColumns() {
			return [
            {
				title: "No",
				type: 'index',
			},
            {
				title: "SKU",
				key: 'sku',
			},
            {
				title: "退货数量",
				key: 'qty'
			},
            {
				title: "接收数量",
				key: 'receivedQty',
			},
            {
				title: "建议处理方式",
				key: 'goodsReturnType',
			},

            {
				title: "更新时间",
				key: 'updatedAt',
                render:(h, {row})=>{
                    return row.updatedAt || '--'
                }
            }];
		},
        getPhotoColumns(){
            return[
                {
                    title: 'No',
                    type: 'index'
                },
                {
                    title: 'SKU',
                    key: 'sku'
                },
                {
                    title: '计划数量',
                    key:'qty'
                },
                {
                    title: '处理数量',
                    key:'qtyDone'
                },
                {
                    title: '照片',
                    render: (h, {row})=>{
                        let img = [];
                        if(row.picturesUrl){
                            row.picturesUrl.map((item, index) => {
                                let newUrl = item + '?image_process=image/resize,w_100&x-oss-process=image/resize,w_100'
                                img.push(
                                    <div style="float: left; cursor: pointer; margin-right: 10px;" onClick={this.handleImgModal.bind(this, {url: index, urlList: row.picturesUrl})}>
                                        <img style="width: 50px; height: 50px;" src={newUrl} />
                                    </div>
                                )
                            });
                        }
                        else{
                            img = '--'
                        }
                        return (
                            <div style="padding: 10px 0; overflow: hidden;">
                                {img}
                            </div>
                        );
                    }
                },
                {
                    title: '照片备注',
                    render: (h,{row})=>{
                        return row.remark || '--'
                    }
                },
                {
                    title: '建议处理方式/更换后SKU',
                    render:(h,{row})=>{
                        return <div>
                            <div>{ row.goodsReturnType || '--' }</div>
                            <div>{ row.newSku || '--' }</div>
                        </div>
                    }
                },
                {
                    title: '处理备注',
                    render: (h,{row})=>{
                        return row.processRemark || '--'
                    }
                },
                {
                    title: '创建时间',
                    key:'updatedAt'
                },
            ]
        },
        getStatus() {
			return this.type !== 'add' && this.formData.saleReturnPlanStatus
		},
        getProgressStatus() {
            const arr = [
                {
                    name: this.$t('fbb.inbound.draft',{defaultValue:'草稿'}),
                    value: '0',
                },
                {
                    name: this.$t('fbb.inbound.check_pending',{defaultValue:'待审核'}),
                    value: '5',
                },
                {
                    name: this.$tc('fbb.sales.sales_status', 2, { defaultValue: '待收货' }),
                    value: '30',
                },
                {
                    name: this.$tc('fbb.sales.sales_status', 2, { defaultValue: '收货中' }),
                    value: '10',
                },
                {
                    name: this.$tc('fbb.sales.sales_status', 2, { defaultValue: '收货完成' }),
                    value: '70',
                }]
			return arr
        }
	},
	methods: {
        closemodalprops(){
            this.modalProps = {};
            this.$emit('on-openCloseable');
        },
        handleImgModal (obj) {
            this.$emit('on-closeCloseable');
            this.modalProps = {
                show: true,
                title: this.$t('global.photo.info', { defaultValue: '照片信息' }),
                component: "compPhoto",
                currentUrl: obj.url,
                urlList: obj.urlList,
                showFooter: false,
                width: 1200,
                // url: url,
            }
        },
        handleOperates(params, type) {
            switch (type) {
                case "query":
                    var url = this.$router.resolve({
                        name: "salesHandlePlanManageDetail",
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
            }
        },
		//获取计划单详情
		getDetail() {
			this.loading = true;
			HttpPlanOrderDetail({ id: this.id }).then(res => {
				const data = res.data || {};
				this.formData = data.saleReturnPlanOrderBaseInfo;
				this.productList = data.saleReturnPlanOrderItems;
                this.photoList = data.saleReturnOrderItems;
				this.logList = data.opLogEntityList;
                this.attachList = data.orderAttachesEntities;
                this.photoData.orderData = this.formData;
                this.photoData.orderType = 5;
				this.loading = false;
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(this.$t(err.langCode, { defaultValue: err.message }));
			})
		},

		//完成
		complateBill() {
            this.$emit('on-closeCloseable');
			this.modalProps = {
				show: true,
				title: "完成",
				alert: "success",
				width: "middle",
				showDesc: false,
				params: { id: this.id, status: 70 },
				ajaxRequest: HttpChangePlanOrderStatus,
				formdata: [
					{
						tag: "vTextarea",
						key: "remark",
						labelWidth: 'auto',
						span: 24,
						label: "备注",
					}
				],
			}
		},
        // 重处理
        rehandle(){
            this.$emit('on-closeCloseable');
            this.modalProps = {
				show: true,
				title: "重处理",
				alert: "error",
				showDesc: true,
				params: { id: this.id },
				ajaxRequest: HttpChangePlanOrderReprocess,
			}
        },
        // 忽略异常
        ignoreAbnormal(){
            this.$emit('on-closeCloseable');
            this.modalProps = {
				show: true,
				title: "忽略异常",
				alert: "error",
				showDesc: true,
				params: { id: this.id },
				ajaxRequest: HttpChangePlanOrderIgnoreError,
			}
        },
        // 重推仓库
        rePush(){
            this.$emit('on-closeCloseable');
            this.modalProps = {
				show: true,
				title: "重推仓库",
				alert: "error",
				showDesc: true,
				params: { id: this.id },
				ajaxRequest: HttpChangePlanOrderRepushWareHouse,
			}
        },
		// 审核
		async approve() {
            this.$emit('on-closeCloseable');
            this.modalProps = {
                show: true,
                title: "审核",
                alert: "success",
                showDesc: false,
                width: "middle",
                params: { id: this.id, status: 30, },
                ajaxRequest: HttpChangePlanOrderStatus,
                formdata: [
                    {
                        tag: "vRadio",
                        key: "status",
                        labelWidth: 'auto',
                        default: 30,
                        span: 24,
                        label: "审核",
                        options: [{
                            trueValue: 30,
                            label: '审核通过',
                        }]
                    },
                    {
                        tag: "vTextarea",
                        key: "remark",
                        labelWidth: 'auto',
                        span: 24,
                        label: "备注",
                        required: false
                    }
                ],
            }
		},
		cancel() {
			this.$router.push({
				name: 'salesreturnsPlanmanage'
			})
		}
	}
};
</script>
